import "./UserDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import commonService from "../../../../../shared/services/common.service";
import {CommonService} from "../../../../../shared/services";
import React from "react";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";

interface UserDetailsViewComponentProps {
    userDetails: any;
    canEdit: boolean;
    onEditModeOpen: Function;
}

const UserDetailsViewComponent = (props: UserDetailsViewComponentProps) => {
    const {userDetails, canEdit, onEditModeOpen} = props;

    return (
        <div className={'user-details-view-component  details-tab-data-content'}>
            {
                userDetails && <>
                    <div className="details-tab-data-header">
                        <div className="view-and-edit-title">Personal Details</div>
                        {canEdit &&
                            <div className={'edit-action-button'}>
                                <ButtonComponent
                                    className={"white-space-nowrap"}
                                    type="button"
                                    color={"primary"}
                                    variant={"outlined"}
                                    startIcon={<EditIcon/>}
                                    fullWidth={true}
                                    disabled={userDetails?.isPhysician}
                                    handleClick={onEditModeOpen}
                                >
                                    Edit Details
                                </ButtonComponent>
                            </div>
                        }
                    </div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"First Name"}> {commonService.capitalizeFirstLetterOfEachWord(userDetails?.firstName) || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Last Name"}> {commonService.capitalizeFirstLetterOfEachWord(userDetails?.lastName) || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Gender"}> {userDetails?.gender || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Middle Name"}> {commonService.capitalizeFirstLetterOfEachWord(userDetails?.middleName) || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Date of Birth"}> {userDetails?.dateOfBirth ? commonService.formatDate(userDetails?.dateOfBirth) : 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                        <div className="horizontal-line"/>
                        <div className="view-and-edit-title">Contact Details</div>
                        <div className="details-tab-data-body">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Email ID"}> {userDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(userDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Role"}> {userDetails?.roleObj?.title || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                        </div>
                        {
                            ["location", "facility", "lab"].map(key => (
                                userDetails[key] && (
                                    <>
                                        <div className="horizontal-line"/>
                                        <div className="view-and-edit-title">Linked Details</div>
                                        <div className="details-tab-data-body">
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                                    <DetailsDataKeyValueComponent
                                                        fullWidth
                                                        title={key.charAt(0).toUpperCase() + key.slice(1)}>
                                                        {
                                                            Array.isArray(userDetails[key]) ?
                                                                userDetails[key]?.map((entity: any, index: number) => {
                                                                    return <ChipComponent key={index}
                                                                                          label={entity.name || "N/A"}/>
                                                                }) : userDetails[key]?.name || "N/A"
                                                        }
                                                    </DetailsDataKeyValueComponent>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </>
                                )
                            ))
                        }

                    </div>
                </>
            }
        </div>
    );

};

export default UserDetailsViewComponent;
